import React, { useEffect, useMemo } from 'react';

import { useBaseEventProperties } from '~hooks/selectors/useBaseEventProperties';
import { useLogout } from '~hooks/useLogout';

import { ErrorIcon } from '~assets/images';
import {
	ConfiningBillingDelinquencyTier,
	DELINQUENCY_BLOCKED_COPY,
} from '~constants/billing/delinquency';
import { BILLING_EVENTS } from '~constants/fullstory/events/billing';
import { trackEvent } from '~third-party/fullstory';

import { BaseBillingSuspensionModal } from './BaseBillingSuspensionModal';

interface BillingAccessBlockedModalProps {
	tier: ConfiningBillingDelinquencyTier;
}

export const BillingAccessBlockedModal = ({
	tier,
}: BillingAccessBlockedModalProps): React.JSX.Element => {
	const { logout } = useLogout();
	const baseEventProperties = useBaseEventProperties();
	const eventProperties = useMemo(
		() => ({ ...baseEventProperties, tier }),
		[baseEventProperties, tier],
	);

	useEffect(() => {
		trackEvent(
			BILLING_EVENTS.DELINQUENCY_ACCESS_BLOCKED_MODAL_VIEWED,
			eventProperties,
		);
	}, [eventProperties]);

	const handleLogout = (): void => {
		trackEvent(
			BILLING_EVENTS.DELINQUENCY_ACCESS_BLOCKED_LOGOUT_CLICKED,
			eventProperties,
		);
		void logout();
	};

	// Unlike the Owner modal it is a wall (no onDismiss) and keeps the error icon: a
	// non-Owner has no recovery from this state.
	return (
		<BaseBillingSuspensionModal
			titleIcon={ErrorIcon}
			title={DELINQUENCY_BLOCKED_COPY.title}
			submitText={DELINQUENCY_BLOCKED_COPY.action}
			onSubmit={handleLogout}
		>
			{DELINQUENCY_BLOCKED_COPY.body}
		</BaseBillingSuspensionModal>
	);
};
